import { Link as SmoothLink } from 'react-scroll';
// import BtBottom from "../../../assets/img/icons/bt_arrow_bottom_white.svg";

const BtNext = (props) => {
	const { className, top, color, url } = props;
	const directionClass = top ? 'bt_top' : 'bt_bottom';
	const colorClass = color ? `bt_${ color }` : '';
	return(
		<SmoothLink
				className={`bt_next cursor_pointer ${ className } ${directionClass} ${ colorClass }`}
				to={ url }
				smooth={true}
				hashSpy={true}
				offset={0}
				duration={500}
		></SmoothLink>



	);
}
export default BtNext;
